import {BrowserRouter, Route, Routes} from "react-router-dom";
import React, {lazy} from "react";
import './App.css';


const Home = lazy(() => import("./pages/Home"));
const InserisciPratica = lazy(() => import("./pages/InserisciPratica"));

function App() {


    return (

        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/inserisci-pratica" element={<InserisciPratica/>}/>
            </Routes>
        </BrowserRouter>


    );
}

export default App;
